import { useState } from "react";
import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import InquiryModal from "@/components/product/InquiryModal";

export default function ProductCard({ product, index = 0 }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, delay: index * 0.04 }}
        viewport={{ once: true }}
      >
        <Card
          data-testid={`product-card-${product.id}`}
          className="group h-full overflow-hidden rounded-sm border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
        >
          <div className="aspect-[4/3] overflow-hidden bg-slate-100">
            <img
              src={product.image}
              alt={product.name}
              data-testid={`product-image-${product.id}`}
              className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <CardContent className="space-y-4 p-5">
            <Badge
              variant="outline"
              data-testid={`product-category-${product.id}`}
              className="rounded-sm border-slate-300 text-xs text-slate-700"
            >
              {product.category}
            </Badge>

            <div>
              <h3
                data-testid={`product-name-${product.id}`}
                className="font-heading text-xl font-semibold text-slate-900"
              >
                {product.name}
              </h3>
              <p data-testid={`product-description-${product.id}`} className="mt-2 text-sm text-slate-600">
                {product.description}
              </p>
            </div>

            <ul className="space-y-1">
              {product.specs.map((spec) => (
                <li
                  key={spec}
                  data-testid={`product-spec-${product.id}-${spec.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-xs text-slate-500"
                >
                  • {spec}
                </li>
              ))}
            </ul>

            <Button
              data-testid={`product-inquiry-button-${product.id}`}
              className="w-full rounded-sm bg-orange-500 text-white hover:bg-orange-600"
              onClick={() => setOpen(true)}
            >
              Get Price / Send Inquiry
            </Button>
          </CardContent>
        </Card>
      </motion.div>

      <InquiryModal product={product} open={open} onOpenChange={setOpen} />
    </>
  );
}
